import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import images from './assets/images'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as api from './api/home'
import menus from './components/menus'
import leftMenu from './components/leftMenu'
import leftMenuList from './components/leftMenuList'
import tTabs from './components/tTabs'
import steps from './components/steps'
import footers from './components/footers'
import rightNav from './components/rightNav'

Vue.config.productionTip = false
Vue.prototype.$images = images
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$https = api
Vue.prototype.$baseUrl = 'http://cx.okweizhan.com'

Vue.component('menus', menus)
Vue.component('leftMenu', leftMenu)
Vue.component('leftMenuList', leftMenuList)
Vue.component('tTabs', tTabs)
Vue.component('steps', steps)
Vue.component('footers', footers)
Vue.component('rightNav', rightNav)
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
